import { GET_VOUCHERS } from "./action";

const initialState = {
  vouchers: { totalRows: 0, items: [] },
  filters: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_VOUCHERS:
      return { ...state, vouchers: action.payload };
    default:
      return state;
  }
};
